import { BENEFIT_TYPE_LONG_TERM_DISABILITY } from '@hixme/benefit-types'
import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import { datadog } from 'helpers/datadog'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import cart from 'store/modules/cart'
import person from 'store/modules/persons'
import { isImpersonating } from 'store/modules/user-session/selectors'

const mapStateToProps = (state, { data, flags }) => ({
  coveredPersons: data.persons,
  benefitProducts: [data.benefit],
  isProcessing:
    getWaiter(state, cart.constants.getBenefitPath(BENEFIT_TYPE_LONG_TERM_DISABILITY)).isPending ||
    false,
  isActivityLogEnabled: flags['enrollme.activity-log-reason-popup-enabled'],
  isImpersonated: isImpersonating(state),
  isTestUser: person?.selectors?.getPersonSelector(state)?.IsTestUser,
})

const mapDispatchToProps = (dispatch) => ({
  onDeclineClick: (
    coveredPersons,
    [benefit],
    _,
    { isActivityLogEnabled, isImpersonated, isTestUser }
  ) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      dispatch(
        cart.actions.declineBenefit(BENEFIT_TYPE_LONG_TERM_DISABILITY, coveredPersons, benefit)
      ).then(
        () => {
          logGenericActivity({
            additionalData: { coveredPersons, benefit, reason, reasonCategory, zendeskTicket },
            activity: 'declined long term disability coverage',
            action: ShopForHealthAction.DeclineLongTermDisabilityCoverage,
          })
          datadog.declineBenefits(BENEFIT_TYPE_LONG_TERM_DISABILITY, coveredPersons, benefit)
          dispatch(clearModal())
        },
        () => {
          dispatch(clearModal())
          dispatch(
            createErrorNotification(
              'There was an error declining long term disability coverage. Please try again.'
            )
          )
        }
      )
    }

    handleActivityLogPopup({
      isImpersonated,
      isTestUser,
      isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to decline this long term disability coverage?',
      onSubmit: callback,
    })
  },
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(DeclineCoverageModal))
